import { V1 } from 'api/v1/V1';
import { getClientTimeInISO } from 'library/utils/dateTime/clientTime';

export interface PrintProtocolUserSettings {
	printQr: boolean;
	printEstimatedHours: boolean;
	printUsedHours: boolean;
	printConfiguration: boolean;
	printEndCustomer: boolean;
	printCampaigns: boolean;
	printCoverage: boolean;
	printProposals: boolean;
	printServiceActivitiesPhotos: boolean;
	printAdditionalRepairs: boolean;
	printAdditionalPhotos: boolean;
	printSignatures: boolean;
}

export interface PrintProtocolFormType extends PrintProtocolUserSettings {
	additionalText?: string;
}

type GetServiceProtocolPdfQuery = Parameters<
	InstanceType<typeof V1>['downloadServiceProtocolPdf']
>['0'];

export type VppnReverseProxyType = 'securewss' | 'msappproxy.net';

export const mapFormToPdfRequest = (
	protocolId: number,
	form: PrintProtocolFormType,
	vppnReverseProxyType: VppnReverseProxyType | undefined,
	isOffline: boolean,
	isDealer: boolean
): GetServiceProtocolPdfQuery => ({
	id: protocolId,
	vppnReverseProxyType,
	additionalText: form.additionalText ?? '',
	protocolGenerationClientDate: getClientTimeInISO() as unknown as Date, // workaround for sending date as date, generated client sends it as string
	printQr: isDealer ? form.printQr : false,
	printEstimatedHours: isOffline ? false : form.printEstimatedHours,
	printUsedHours: isOffline ? false : form.printUsedHours,
	printConfiguration: form.printConfiguration,
	printEndCustomer: form.printEndCustomer,
	printCampaigns: form.printCampaigns,
	printCoverage: form.printCoverage,
	pritntProposals: isOffline ? false : form.printProposals,
	printActivitiesPhotos: form.printServiceActivitiesPhotos,
	printAdditionalRepairs: form.printAdditionalRepairs,
	printAdditionalRepairPhotos: form.printAdditionalPhotos,
	printSignaures: form.printSignatures,
});

export const mapRecordToUserSettings = (
	dict?: Record<string, boolean>
): PrintProtocolUserSettings | undefined => {
	if (!dict) {
		return undefined;
	}

	const {
		printQr,
		printEstimatedHours,
		printUsedHours,
		printConfiguration,
		printEndCustomer,
		printCampaigns,
		printCoverage,
		printProposals,
		printServiceActivitiesPhotos,
		printAdditionalRepairs,
		printAdditionalPhotos,
		printSignatures,
	} = dict;

	return {
		printQr: printQr ?? true,
		printEstimatedHours: printEstimatedHours ?? true,
		printUsedHours: printUsedHours ?? true,
		printConfiguration: printConfiguration ?? true,
		printEndCustomer: printEndCustomer ?? true,
		printCampaigns: printCampaigns ?? true,
		printCoverage: printCoverage ?? true,
		printProposals: printProposals ?? true,
		printServiceActivitiesPhotos: printServiceActivitiesPhotos ?? true,
		printAdditionalRepairs: printAdditionalRepairs ?? true,
		printAdditionalPhotos: printAdditionalPhotos ?? true,
		printSignatures: printSignatures ?? true,
	};
};
